<template>
  <div class="layout justify-end">
    <v-btn
      depressed rounded dark
      class="strategio-card-button"
      style="background-color:#19BAE8"
      @click="dialog = true"
    >
      Ver reportes
    </v-btn>
    <v-dialog v-model="dialog" max-width="500px" scrollable >
      <v-card class="py-2 strategio-card-container">
        <v-card-title
          class="py-2 justify-center"
          style="font-size:20px;font-weight:500;"
        >Reportes</v-card-title>
        <div class="divisor">
          <v-divider></v-divider>
        </div>
        <v-card-text>
          <reports-tree :items-data="itemsData"></reports-tree>
        </v-card-text>
        <v-card-actions class="layout justify-center">
          <!-- <v-spacer></v-spacer> -->
          <v-btn
            small depressed rounded
            class="strategio-dialog-button"
            color="error"
            @click.native="closeDialog()"
          >Cerrar</v-btn>
          <v-btn
            small depressed rounded
            class="strategio-dialog-button"
            color="success"
            @click.native="updatePermissions()"
          >Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ReportsTree from '../reports/reports-tree.vue'
import reportsStorage from '../../storage/reportsStorage'
import eventBus from '../../utils/eventBus'

export default {
  name: 'show-reports-permisions-dialog',
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    closeDialog () {
      const q = reportsStorage.getCheckedItems(this.itemsData)
      // emit to: components/users/user-form.vue
      eventBus.$emit('show-updated-Reports', q)
      this.dialog = false
    },
    updatePermissions () {
      const q = reportsStorage.getCheckedItems(this.itemsData)
      if (this.isNewUser) {
        // emit to: components/users/user-form.vue
        eventBus.$emit('show-updated-Reports', q)
        this.dialog = false
      } else {
        reportsStorage.updatePermissions({
          userID: this.userId,
          permissions: q,
          onSuccess: () => {
            // emits to: components/snacksbars/custom-snack-bar.vue
            eventBus.$emit('open-custom-snack-bar', {
              message: 'Se actualizo la visualizacion de reportes',
              itsOk: true
            })
            this.dialog = false
          },
          onerror: () => {
            eventBus.$emit('open-custom-snack-bar', {
              // emits to: components/snacksbars/custom-snack-bar.vue
              message: 'Ha habido un error actualizando la visualizacion de reportes',
              itsOk: false
            })
            this.dialog = false
          }
        })
      }
    }
  },
  components: {
    ReportsTree
  },
  props: ['itemsData', 'userId', 'isNewUser']
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/show-reports-permisions-dialog.vue